import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { ShadowingWithApplications } from "../types";

interface Props {
  shadowing: ShadowingWithApplications;
}

const ShadowingCapacity: React.FC<Props> = ({ shadowing }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {t("shadowing.occupied_slots")}: {shadowing.occupiedApplications} {t("common.from")}{" "}
      {shadowing.participantsCapacity}
    </Fragment>
  );
};

export default ShadowingCapacity;
